module.exports = __webpack_public_path__ + "static/img/sybanner-3.42bf4d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sybanner-3.png
// module id = ow8w
// module chunks = 0